import { render, staticRenderFns } from "./points.vue?vue&type=template&id=1a052c06"
import script from "./points.vue?vue&type=script&lang=js"
export * from "./points.vue?vue&type=script&lang=js"
import style0 from "./points.vue?vue&type=style&index=0&id=1a052c06&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-kr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a052c06')) {
      api.createRecord('1a052c06', component.options)
    } else {
      api.reload('1a052c06', component.options)
    }
    module.hot.accept("./points.vue?vue&type=template&id=1a052c06", function () {
      api.rerender('1a052c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/points.vue"
export default component.exports